import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ConfigurationService } from '../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class PlantmachineryService {
  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }
  apiUrl = this.ConfigService.getAPIBaseUrl() + 'api/PlantAndMachinery/';

  insertmachinery(data: any) {
    debugger
    return this.http.post(this.apiUrl + 'Add', data)
  }

  getmachinery(id) {
    debugger
    return this.http.get(this.apiUrl + 'GetOne?id='+id)
  }
  getmachineryLY(id) {
    debugger
    return this.http.get(this.apiUrl + 'GetOneLY?id=' + id)
  }
}

